module.exports = __webpack_public_path__ + "static/media/bg.84c911d9.png";